import React from 'react'
import translate from 'helpers/translate'
import styled from 'styled-components'
import Inset from 'syf-component-library/ui/spacing/Inset'
import Body from 'syf-component-library/ui/typography/Body'
import { colors } from 'theme'

interface RuleProps {
  pristine?: boolean
  hasError?: boolean
}

const Rule = styled(Inset)<RuleProps>`
  display: flex;
  color: ${props => {
    if (props.pristine) return colors.black
    if (props.hasError) return colors.error
    return colors.green
  }};
`

const RulesDescription = styled(Body)`
  color: inherit;
`

const IconWrapper = styled.span`
  padding: 4px 8px 4px 0px;
`

interface RuleItemProps {
  rule: string
  icon: JSX.Element
  pristine?: boolean
  hasError?: boolean
}

const RuleItem: React.FC<RuleItemProps> = ({
  rule,
  icon,
  pristine,
  hasError
}) => {
  const checkRegistrationUserIdRule = (id: string): string => {
    const ruleDescription = {
      minimumSixChar: translate({
        string: 'minimumSixChar'
      }),
      containsLetter: translate({
        string: 'containsLetter'
      }),
      containsNoSpaces: translate({
        string: 'containsNoSpaces'
      }),
      isAllowedFormat: translate({
        string: 'isAllowedFormat'
      }),
      containsNumber: translate({
        string: 'containsNumber'
      }),
      emailAddressPermitted: translate({
        string: 'emailAddressPermitted'
      }),
      readyToGo: translate({
        string: 'readyToGo'
      }),
      length: translate({ string: 'pwdLength' }),
      noWhiteSpace: translate({ string: 'noWhiteSpace' }),
      hasNumber: translate({ string: 'hasNumber' }),
      hasLetter: translate({ string: 'hasLetter' }),
      specialChar: translate({ string: 'pwdSpecialChar' }),
      lastFour: translate({ string: 'lastFour' })
    }

    return ruleDescription[id as keyof typeof ruleDescription]
  }

  return (
    <Rule
      key={rule}
      pristine={pristine}
      hasError={hasError}
      vertical="base"
      horizontal="xsmall"
    >
      <IconWrapper>{icon}</IconWrapper>
      <RulesDescription>{checkRegistrationUserIdRule(rule)}</RulesDescription>
    </Rule>
  )
}

export default RuleItem
